module.exports = __webpack_public_path__ + "img/spIcon.089d683c.png";